import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { CreateMeetingRoomComponent } from './create-meeting-room/create-meeting-room.component';
import { ViewMeetingRoomComponent } from './view-meeting-room/view-meeting-room.component';
import { DetailsMeetingRoomComponent } from './details-meeting-room/details-meeting-room.component';
import { ViewBlockedMeetingRoomComponent } from './view-blocked-meeting-room/view-blocked-meeting-room.component';
import { ViewMeetingRoomBookingComponent } from './view-meeting-room-booking/view-meeting-room-booking.component';

const routes: Routes = [
  { path: 'create-meeting-room', component: CreateMeetingRoomComponent },
  { path: 'view-meeting-room', component: ViewMeetingRoomComponent },
  { path: 'details-meeting-room', component: DetailsMeetingRoomComponent },
  { path: 'view-blocked-meeting-room', component: ViewBlockedMeetingRoomComponent },
  { path: 'view-meeting-room-booking', component: ViewMeetingRoomBookingComponent },
];

@NgModule({
  declarations: [
    CreateMeetingRoomComponent,
    ViewMeetingRoomComponent,
    DetailsMeetingRoomComponent,
    ViewBlockedMeetingRoomComponent,
    ViewMeetingRoomBookingComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AutocompleteLibModule,
    NgSelectModule,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MeetingroomModule { }
